var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data",style:(_vm.elStyle)},[_c('p',[_vm._v(_vm._s(_vm.$t('analytics.noData')))])])}
var staticRenderFns = []

export { render, staticRenderFns }